import { apiDietPrices } from './apiDietPrices'
import { apiPriceTiers } from './apiPriceTiers'
import { apiPriceDiets } from './apiPriceDiets'

const apiPrices = {
	...apiDietPrices,
	...apiPriceTiers,
	...apiPriceDiets,
}

export { apiPrices }
